module.exports = __webpack_public_path__ + "img/chevron-right.efd81263.svg";